import Axios from "axios";
import { refreshToken } from "./refreshtoken";
import { Gatwayhost} from "../../Config";


const employee_axios = Axios.create({
  baseURL: Gatwayhost + "/employee-service/v1",
});


employee_axios.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    config.headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
   async(error) => {
    return Promise.reject(error);
  }
);

employee_axios.interceptors.response.use(

  (response) => {
    return response;
  },

   async(error) => {
    const originalRequest =  error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const resp = await refreshToken();
      const access_token =resp.access.token
      const refresh_token =resp.refresh.token
      localStorage.setItem("token", access_token);
      localStorage.setItem("rToken", refresh_token);
      employee_axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${access_token}`;
      return employee_axios(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default employee_axios;
